import type { EmptyResponse, WithdrawCreateRequest } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class CreateWithdrawUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(body: WithdrawCreateRequest): Promise<EmptyResponse> {
    if (!body || typeof body !== 'object') {
      throw new Error('body is required');
    }
    return this.repository.createWithdraw(body);
  }
}


